import { useEffect, useState, type FormEvent } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/", end: true },
  { label: "电影", to: "/category/movie", end: false },
  { label: "电视剧", to: "/category/tv", end: false },
  { label: "综艺", to: "/category/variety", end: false },
  { label: "专题", to: "/special", end: false },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname, location.search]);

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const trimmed = keyword.trim();
    navigate(trimmed ? `/search?q=${encodeURIComponent(trimmed)}` : "/search");
  };

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/90 backdrop-blur-md">
      <div className="flex h-16 w-full items-center justify-between gap-4 px-4 md:px-8">
        <div className="flex items-center gap-6 lg:gap-10">
          <Link to="/" className="flex items-center gap-2.5" aria-label="WW我的快乐在哪里 首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-600 text-sm font-black text-background-50">
              WW
            </span>
            <span className="font-brand text-lg leading-none text-foreground-950 whitespace-nowrap">
              我的快乐在哪里
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2 text-sm transition-colors whitespace-nowrap ${
                    isActive
                      ? "bg-primary-100 font-semibold text-primary-700"
                      : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>

        <div className="flex items-center gap-2">
          <form onSubmit={handleSearch} className="hidden lg:flex items-center" role="search">
            <div className="flex h-9 items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 focus-within:border-primary-400">
              <i className="ri-search-line text-sm text-foreground-500" aria-hidden="true" />
              <input
                type="search"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索影视 / 剧情"
                aria-label="搜索影视作品"
                className="w-40 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
                name="q"
              />
            </div>
          </form>

          <Link
            to="/search"
            aria-label="搜索"
            className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 hover:text-foreground-950 lg:hidden"
          >
            <i className="ri-search-line text-lg" aria-hidden="true" />
          </Link>

          <button
            type="button"
            onClick={() => setMobileOpen((open) => !open)}
            aria-label="切换菜单"
            aria-expanded={mobileOpen}
            className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 md:hidden"
          >
            <i className={mobileOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true" />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-3 md:hidden">
          <form onSubmit={handleSearch} className="mb-3" role="search">
            <div className="flex h-10 items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3">
              <i className="ri-search-line text-base text-foreground-500" aria-hidden="true" />
              <input
                type="search"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索影视 / 剧情"
                aria-label="搜索影视作品"
                className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
                name="q"
              />
            </div>
          </form>
          <nav className="flex flex-col" aria-label="移动端导航">
            {[...navItems, { label: "关于我们", to: "/about", end: false }].map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-sm ${
                    isActive
                      ? "bg-primary-100 font-semibold text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}